export default __webpack_public_path__ + "static/media/PC-09.5c20bc57.jpg";